import React from 'react';
import { Card, Col, Row, Tabs, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import './ProductCard.css';

type Product = {
    frame_sides_areo: number;
    opening_areo: string;
    lock_predisposition?: string;
    min_passage_width?: number;
    max_passage_width?: number;
    min_passage_height?: number;
    max_passage_height?: number;
    min_overall_width?: number;
    max_overall_width?: number;
    min_overall_height?: number;
    max_overall_height?: number;
}

type ProductUserChoice = {
    width: number;
    height: number;
    measureType: string;
}

type ProductCardProps = {
    product: Product;
    actions?: React.ReactNode[];
    userChoice?: ProductUserChoice;
    coverClassName?: string;
    sizeTabTitle?: string | null;
    hideProductInfo?: boolean;
}

const getProductVersionImage = (productVersion: Product): string => {

    const openingAreo = productVersion.opening_areo;

    return `/build/images/configurator/areo-tech/${openingAreo}_frames_${productVersion.frame_sides_areo}.svg`;
}

const extractProductVersionText = (productVersion: Product, t: TFunction): {
    title: string,
    subtitle: string[]
} => {

    const transKey = `products.version.${productVersion.opening_areo}_frames_${productVersion.frame_sides_areo}`;

    return {
        title: t(`${transKey}.title`),
        subtitle: t(`${transKey}.subtitle`).split(',').map((text: string) => text.trim())
    }
}

const ProductCard = ({ product, userChoice, actions, coverClassName = 'product-cover', sizeTabTitle = null, hideProductInfo = false }: ProductCardProps) => {

    const { t } = useTranslation();

    const productVersionText = extractProductVersionText(product, t);

    return (
        <Card
            className='product-card'
            variant="borderless"
            cover={
                <div className={coverClassName}>
                    <Typography.Title className='text-center text-uppercase mb-0' level={3}>{productVersionText.title}</Typography.Title>
                    <div className='text-center'>
                        {productVersionText.subtitle.map((text: string, index: number) => (
                            <Typography.Title level={5} key={index} className='text-uppercase primary-color my-0'>{text}</Typography.Title>
                        ))}
                    </div>

                    <img src={getProductVersionImage(product)} alt={productVersionText.title} />
                </div>
            }
            actions={actions}>
            {!hideProductInfo && (
                <Row gutter={[16, 16]}>

                    <Col xs={24} lg={24}>
                        <Tabs
                            className='default-cursor-tabs'
                            size='small'
                            tabPosition="top"
                            defaultActiveKey={userChoice ? '1' : '2'}
                            items={userChoice ? [{
                                key: '1',
                                label: sizeTabTitle || t('configurator.user_choice'),
                                children: (
                                    <>
                                        <Typography.Text className='text-uppercase pr-2'>{t('configurator.measure_mode')}:</Typography.Text>
                                        <Typography.Text strong={true} className='text-uppercase'>
                                            {t(`configurator.${userChoice.measureType}`)}
                                        </Typography.Text>
                                        <br />
                                        <Typography.Text className='text-uppercase pr-2'>{t('configurator.width')}:</Typography.Text>
                                        <Typography.Text strong>{userChoice.width} mm</Typography.Text><br />
                                        <Typography.Text className='text-uppercase pr-2'>{t('configurator.height')}:</Typography.Text>
                                        <Typography.Text strong>{userChoice.height} mm</Typography.Text>
                                    </>
                                ),
                            }] : []}
                        />
                    </Col>

                </Row>
            )}
        </Card>
    );
}

export default ProductCard;